import { themeColorsDark } from '@juvare/common-web-ui/JuvareTheme/colors/themeColorsDark';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useDocumentLibraryTranslations } from '../../../hooks';
export const SelectFilesDialogHeader = ({ title, onClose }) => {
    const { t } = useDocumentLibraryTranslations();
    return (React.createElement(Box, { sx: {
            alignItems: 'center',
            backgroundColor: themeColorsDark.background,
            color: themeColorsDark.text.bold,
            display: 'flex',
            justifyContent: 'space-between',
            px: 5,
            py: 2,
        } },
        React.createElement(Typography, { "aria-label": title, variant: 'h6' }, title),
        React.createElement(Box, { sx: {
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'end',
            } },
            React.createElement(Button, { variant: 'text', sx: { p: 0, color: 'inherit', fontSize: '1rem' }, onClick: onClose }, t('common.cancel')))));
};
